import { useEffect, useState, } from 'react'
import { peer } from 'config/skyway';
import { SfuRoom, RoomStream } from 'skyway-js';

type UseRoomPeerValue = {
  localStream?: MediaStream;
  users: Array<RoomStream>;
};

export const useRoomPeer = (id: string): UseRoomPeerValue => {

const [localStream, setLocalStream] = useState<MediaStream>();
const [users, setUsers] = useState<Array<RoomStream>>([]);

  useEffect(() =>{

    const proc = async () => {
      /*
      const roomName = peer.rooms[id]?.name;
      if (!roomName) {
        alert('その部屋がない');
      }*/

      const stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true });

      const room = peer.joinRoom(id, {
        mode: "sfu",
        stream: stream,
      }) as SfuRoom;
      setLocalStream(stream);

      console.log(room);

      room.on('stream', (stream: RoomStream) => {
        console.log(`on stream(id~${stream.id})`);
        setUsers([...users, stream])
      });

      room.on("open", () => {
        console.log(`on open`);
      });

      room.on("peerJoin", (peerId: string) => {
        console.log(`on peerJoin(id=${peerId})`);
      });
    };

    proc();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return { localStream, users } ;
}


type UsePeerValue = {
  close: () => void;
}

export const usePeer = (id: string): UsePeerValue => {

  // close connection 
  const close = () =>{ 
    if (id) {
      peer.rooms[id]?.close();
    }
  }

  return { close } ;
}